<script setup lang="ts">
import type { Brand } from "~/advertisorsData/shared/types";
import EvangelistAmbasador from "~/components/EvangelistAmbasador.vue";

defineProps<{ brand: Brand }>();
</script>
<template>
  <header class="py-3 pt-6 header px-4 lg:px-0 mt-0 lg:mt-6">
    <div class="container-950 flex gap-4 justify-between items-center">
      <NuxtLink class="flex gap-4 items-center" to="/">
        <img class="" :src="brand.logoUrl" />
      </NuxtLink>
      <EvangelistAmbasador
        :theme-mode="brand.designSchema.darkMode ? 'dark' : 'light'"
      />
    </div>
  </header>
</template>
